<template>
    <div class="homeBox text-center" @click="goHome">
        <span class='ilbk homeImg'>
            <img src="../../assets/imgs/home.png" alt="">
        </span>
        <span class='gray-6 lineHe14 padding5-left ft14'>首页</span>
    </div>
  
</template>

<script>
// import CourseDetails from './tab/courseDetails'
export default {
  name: 'Gohome',
  components: {   
  },
  methods: {
      goHome(){
          this.$router.push({
                path:'/',
            })
      },

      },
}
</script>
<style scoped lang="less">
.homeBox{
    position: fixed;
    bottom:35%;
    right: 0;
    width:74/20rem;
    height:39/20rem;
    line-height:39/20rem;
    background:rgba(255,255,255,1);
    box-shadow:0px 2px 6px 2px rgba(22,22,19,0.11);
    border-radius:20px;
}
.homeImg{
    width: .7rem;
    height: .7rem;
}
</style>
